import { SET_AUTHENTICATED,SET_UNAUTHENTICATED,
     LOADER_CHECK, LOADER_FALSE, ROOM_LIST,
     ROOM_PHONE_DATA,ROOM_ALL_GRAPH} from '../type'

const initialState = {
    RoomtList:[],
    RoomPhoneData:[],
    loader:false,
    RoomGraph:[]
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_UNAUTHENTICATED:
            return initialState;
            case ROOM_LIST:
                return {
                    ...state,
                    RoomtList: action.payload,
                    loading: false
                }

                case ROOM_ALL_GRAPH:
                return {
                    ...state,
                    RoomGraph: action.payload,
                    loading: false
                }
                
                case ROOM_PHONE_DATA:
                return {
                    ...state,
                    RoomPhoneData: action.payload,
                    loading: false
                }
                case LOADER_CHECK:
                        return {
                            ...state,
                            loader:true,
                        }
                        case LOADER_FALSE:
                            return { 
                                ...state,                               
                                loader:false,
                            }
           
                default: 
                return state;
    }


}

